import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'
import BaseStore from './global/base'
import SettingStore from './global/setting'
import InformStore from './global/inform'
import MiniFateFortuneStore from './plugins/minifatefortune'
import AllRecordStore from './plugins/allrecord'
import RecordLetterStore from './plugins/recordletter'
import ChooseRecordStore from './plugins/chooserecord'
import GroupStore from './modules/group'
import LabelStore from './modules/label'
import CollateStore from './modules/collate'
import RecordStore from './modules/record'
import SearchStore from './modules/search'
import DetailStore from './modules/detail'
import EditStore from './modules/edit'
import CommentStore from './modules/comment'
import OtherCommentStore from './modules/othercomment'
import DiscussStore from './modules/discuss'
import ShareStore from './modules/share'
import OtherShareStore from './modules/othershare'
import EmbeddedStore from './modules/embedded'
import DonateStore from './modules/donate'
import ReminderStore from './modules/reminder'
import ReportStore from './modules/report'
import FamousPediaStore from './modules/famouspedia'
import FamousPediaCommentStore from './modules/famouspediacomment'
import PayStore from './modules/pay'
import WebLoginStore from './modules/weblogin'

Vue.use(Vuex);

// 定义一些存在状态里的数据变量
const state = {
    public: {
        curPath: ''
    },
    global: {
        gotUserTypeData: false
    },
    userData: {},
    import: { showPopup: false },
    editChangeBirthday: false
}

export default new Vuex.Store({
    modules: {
        base: BaseStore,
        setting: SettingStore,
        inform: InformStore,
        group: GroupStore,
        label: LabelStore,
        collate: CollateStore,
        record: RecordStore,
        allrecord: AllRecordStore,
        recordletter: RecordLetterStore,
        chooserecord: ChooseRecordStore,
        search: SearchStore,
        detail: DetailStore,
        edit: EditStore,
        share: ShareStore,
        othershare: OtherShareStore,
        comment: CommentStore,
        othercomment: OtherCommentStore,
        discuss: DiscussStore,
        minifatefortune: MiniFateFortuneStore,
        embedded: EmbeddedStore,
        donate: DonateStore,
        reminder: ReminderStore,
        report: ReportStore,
        famouspedia: FamousPediaStore,
        famouspediacomment: FamousPediaCommentStore,
        pay: PayStore,
        weblogin: WebLoginStore
    },
    state,
    getters: {
        groupData() {
            return state.group.groupData
        },
        commentAllSelectedList() {
            var resultData = state.famouspediacomment.commentAllSelectedList.sort((a, b) => {return state.famouspediacomment.commentAllSort == 1 ? b.time - a.time : a.time - b.time});
            return resultData;
        },
        commentAllMainList() {
            var resultData = state.famouspediacomment.commentAllMainList.sort((a, b) => {return state.famouspediacomment.commentAllSort == 1 ? b.time - a.time : a.time - b.time});
            return resultData;
        }
    },
    mutations, 
    actions
})